module.exports = __webpack_public_path__ + "static/img/271_TO8_2379.446c7f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/271_TO8_2379.jpg
// module id = kogA
// module chunks = 0